import React, { useEffect, useState } from "react";
import {
  Mail,
  User,
  ChevronDown,
  ArrowLeft,
  GraduationCap,
  MapPin,
  Phone,
  User2Icon,
  UserIcon,
  FlagTriangleLeft,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "../../axios";
import { useTranslation } from "react-i18next";
import { errorToast } from "../../utils/toast";
import toast from "../../componant/Toast/Toast";
import { useUser } from "../../hooks/use-user";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaAngleDown, FaAngleLeft, FaUser } from "react-icons/fa";
import { FaAnglesLeft } from "react-icons/fa6";
import Image from "../../Images/detailsPageImage.PNG";
import Flag from "../../Images/flag2.png";
import { IoChevronBack } from "react-icons/io5";
/* ---------------- MAIN ---------------- */
const WatsApp = () => {
  const navigate = useNavigate();
  const [t] = useTranslation();
  const [states, setStates] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    qualification: "",
    userState: "",
    mobile: "",
    mobileVerified: true,
    loginType: "",
    termsAccepted: false,
    privacyAccepted: false,
    isAdultConfirmed: false,
    consentAcceptedAt: "2025-01-05T12:10:00Z",
  });

  const { data: fetchedUser } = useUser();

  /* -------- Prefill Profile -------- */
  useEffect(() => {
    if (!fetchedUser) return;

    setFormData((prev) => ({
      ...prev,
      name: fetchedUser.name || "",
      qualification: fetchedUser.
qualification || "",
      userState: fetchedUser.userState || "",
      mobile: fetchedUser.mobile || "",
      email: fetchedUser.email || "",
      loginType: fetchedUser.loginType || "",
    }));
  }, [fetchedUser]);

  /* -------- Fetch States -------- */
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const res = await axios.get("/all");
        setStates(res.data?.data || []);
      } catch (err) {
        toast(err.response?.data?.message || "Failed to fetch states", 3000);
      }
    };

    fetchStates();
  }, []);

  /* -------- Update User -------- */
  const updateUser = async () => {
    try {
      const res = await axios.post("/userUpdate", formData);

      if (res.data.result.mobileVerified) {
        navigate("/dash");
      } else {
        toast("Phone Number Already Exist", 3000);
      }
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Phone number already exists";

      errorToast(msg);
    }
  };

  /* -------- Validation -------- */
  const validateForm = () => {
    if (!formData.name.trim()) return errorToast("Please enter full name");

    if (!formData.email.trim())
      return errorToast("Please enter email");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(formData.email))
      return errorToast("Please enter valid email");

    if (!formData.qualification)
      return errorToast("Please select education");

    if (!formData.userState)
      return errorToast("Please select state");

    return true;
  };

  /* -------- Submit -------- */
  const handleSubmit = async () => {
    if (!validateForm()) return;

    const isValidMobile = (mobile) =>
      /^(\+91)?[6-9]\d{9}$/.test(mobile);

    if (!isValidMobile(formData.mobile)) {
      alert("Please enter valid WhatsApp number");
      return;
    }

    const finalFormData = {
      ...formData,
      mobileVerified: true,
    };

    await updateUser(finalFormData);
  };

  /* -------- Change -------- */
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      let mobile = value.replace(/[^\d+]/g, "");

      if (!mobile.startsWith("+")) {
        mobile = "+91" + mobile;
      }

      mobile = mobile.slice(0, 13);

      setFormData((prev) => ({
        ...prev,
        mobile,
        mobileVerified: false,
      }));

      return;
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };

 return (
  <div className="bg-[#F8F8F8] flex flex-col">
    
    {/* Header */}
    <div className="flex items-center gap-4 px-5 pt-10 pb-6">
      <button
        onClick={() => navigate(-1)}
        className="w-14 h-14 rounded-full bg-[#EFEFEF] flex items-center justify-center shadow-sm"
      >
        <IoChevronBack className="text-xl text-black" />
      </button>

      <h1 className="text-2xl sm:text-3xl font-bold text-black">
        Edit Profile
      </h1>
    </div>

    {/* Main Content */}
    <div className="w-full max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-10 px-5 pb-10">
      
      {/* LEFT IMAGE - DESKTOP ONLY */}
      <div className="hidden lg:flex">
        <img
          src={Image}
          alt="Details"
          className="w-[450px] h-[450px] object-contain"
        />
      </div>

      {/* FORM */}
  
<div className="w-full lg:w-1/2 flex flex-col items-left lg:items-start">

  {/* Full Name */}
  <div className="w-full bg-[#F7F7F7] border border-[#D9D9D9] rounded-xl px-1 py-1 mb-4 shadow-sm flex items-center gap-4">
    
    <div className="text-[#3F3F3F] pl-3">
      <UserIcon size={30} strokeWidth={1.8} />
    </div>

    <div className="flex-1 text-left">
      <p className="text-[#5B1C83] text-sm sm:text-base mb-1">
        Enter Full Name
      </p>

      <input
        type="text"
        name="name"
        value={formData.name}
        onChange={handleChange}
        placeholder="Enter Full Name"
        className="w-full bg-transparent border-none outline-none focus:outline-none focus:ring-0 text-xl sm:text-xl text-[#3D3D3D]"
      />
    </div>
  </div>

  {/* Email */}
  <div className="w-full bg-[#F7F7F7] border border-[#D9D9D9] rounded-xl px-1 py-1 mb-4 shadow-sm flex items-center gap-4">
    
    <div className="text-[#3F3F3F] pl-3">
      <Mail size={30} strokeWidth={1.8} />
    </div>

  <div className="flex-1 text-left">
  <p className="text-[#5B1C83] text-sm sm:text-base mb-1">
    Enter Email
  </p>

  <input
    type="email"
    name="email"
    value={formData.email}
    disabled
    placeholder="Enter Email"
    className="w-full bg-transparent border-none outline-none text-xl sm:text-xl text-[#3D3D3D] cursor-not-allowed"
  />
</div>
  </div>

  {/* Education */}
  <div className="w-full  bg-[#F7F7F7] border border-[#D9D9D9] rounded-xl px-1 py-1 mb-4 shadow-sm flex items-center gap-4">
    
    <div className="flex-1 relative">
      <select
        name="qualification"
        value={formData.qualification}
        onChange={handleChange}
        className="w-full appearance-none bg-transparent border-none outline-none text-xl sm:text-xl text-black"
      >
        <option value="">Select an education Level</option>
        <option value="10th">10th</option>
        <option value="12th">12th</option>
        <option value="Diploma/iti">Diploma / ITI</option>
        <option value="Graduate/Bachelor">Graduate</option>
        <option value="Post Graduate/Master">
          Post Graduate
        </option>
      </select>
    </div>
  </div>

  {/* State */}
  <div className="w-full  bg-[#F7F7F7] border border-[#D9D9D9] rounded-xl px-1 py-1 mb-4 shadow-sm flex items-center gap-4">
    
    <div className="flex-1 relative">
      <select
        name="userState"
        value={formData.userState}
        onChange={handleChange}
        className="w-full appearance-none bg-transparent border-none outline-none text-xl sm:text-xl text-black"
      >
        <option value="">Select State</option>

        {states.map((state) => (
          <option
            key={state.fullName}
            value={state.fullName}
          >
            {state.fullName}
          </option>
        ))}
      </select>

    </div>
  </div>

  {/* Mobile */}
 <div className="w-full bg-[#F7F7F7] border border-[#D9D9D9] rounded-xl px-1 py-1 mb-4 shadow-sm flex items-center gap-4 opacity-60 pointer-events-none">
  <div className="text-[#3F3F3F] pl-3">
    <img src={Flag} alt="Flag" className="w-8 h-8" />
  </div>

  <FaAngleDown size={20} className="text-black" />

  <div className="flex-1">
    <input
      type="tel"
      disabled
      name="mobile"
      value={formData.mobile}
      placeholder="+91 3000000000"
      className="w-full bg-transparent border-none outline-none text-xl text-black"
    />
  </div>
</div>
  {/* Submit Button */}
 {/* Submit Button */}
<div className="w-full mt-8">
  <button
    onClick={handleSubmit}
    className="
      w-full
      h-16
      bg-[#F4A91F]
      rounded-full
      text-white
      text-xl sm:text-2xl
      font-medium
      shadow-[0_10px_20px_rgba(0,0,0,0.12)]
      hover:scale-[1.01]
      transition-all duration-300
    "
  >
    Submit
  </button>
</div>

  </div>
</div>


    <ToastContainer position="top-center" />
  </div>
);
};

export default WatsApp;